import BookFreeClassBtn from '@components/common/book-free-class-btn'
import ClassesOverview from '@components/home/group-classes/classes-overview'
import useResolution from '@hooks/useResolution'
import dynamic from 'next/dynamic'
const ClassesTable = dynamic(() =>
  import('@components/home/group-classes/classes-table')
)
const ClassesTableMobile = dynamic(() =>
  import('@components/home/group-classes/classes-table-mobile')
)

/** i18n support added */
const GroupClasses = () => {
  const {
    sizes: { sm: isMobileDevice },
  } = useResolution()
  return (
    <div className="flex flex-col py-10 space-y-16">
      <ClassesOverview />
      {!isMobileDevice && <ClassesTable />}
      {isMobileDevice && <ClassesTableMobile />}
      <div className="mx-auto px-5 md:px-0 w-full lg:w-auto lg:px-0">
        <BookFreeClassBtn size="xl" />
      </div>
    </div>
  )
}

export default GroupClasses
